import React from 'react'
import { TextPage } from './TextPage'
import textForm from './texts/termsOfService'

export const TermsOfService = () => {
  return <TextPage textForm={textForm} />
}
